export const GET_AUTOCOMPLETE_LOCATION = 'GET_AUTOCOMPLETE_LOCATION';

